import React, { useEffect, useState } from "react";
import {ServicesListViewModel} from "../../Partials/ServicesList/ServicesListViewModel.csharp"

const ServicesNumberBreakpoint = 6;


export const ServicesNotOffered: React.FC<ServicesListViewModel> = ({
  heading,
  items
}) => {
    const [showAll, setShowAll] = useState(items.length <= ServicesNumberBreakpoint);
    
    const servicesSlice = showAll
        ? items
        : items.slice(0, ServicesNumberBreakpoint);

    return (
        <div className="related-block mb-4 mb-lg-5">
            <h2 className="h4">{heading}</h2>
            <ul className="pipe-list ps-0">
                {servicesSlice.map((l, i) => (
                    <li className="pipe-list__item" key={i}>
                        <a href={l.link.url}>{l.link.title}</a>
                    </li>
                ))}
            </ul>

            {!showAll && (
                <button
                    className="btn-link link-list--simple__load-more__small"
                    onClick={() => setShowAll(true)}
                >
                    Vis flere
                </button>
            )}
        </div>
    );
};